import React from 'react';
import { RaisedButton, Slider } from 'material-ui';
import ReactDom from 'react-dom';
import { isDataURL } from './is-data-url';
import warning from 'warning';
import Icon from '../../tc-ui/icon';

const numberableType = (props, propName, componentName) => {
  warning(
    !isNaN(parseInt(props[propName])),
    `Invalid ${propName} '${props.size}' sent to '${componentName}'. Requires an
    int or string capable of conversion to an int.
    Check the render method of == '${componentName}'. == `
  );
};

class Cropper extends React.Component {
  constructor(props) {
    super(props);
    // getInitialState
    this.state = {
      showHelper: true,
      dragging: false,
      image: {},
      mouse: {
        x: null,
        y: null,
      },
      preview: null,
      canvasWidth: props.round ? props.height : props.width,
      canvasHeight: props.height,
      zoom: 1,
    };
    this.listeners = [];
  }
  componentDidMount() {
    const canvas = ReactDom.findDOMNode(this.refs.canvas);
    this.prepareCanvas();
    this.prepareImage(this.props.image);
    this.listeners = {
      mousemove: e => this.mouseMoveListener(e),
      mouseup: e => this.mouseUpListener(e),
      mousedown: e => this.mouseDownListener(e),
    };
    canvas.addEventListener('mousemove', this.listeners.mousemove);
    canvas.addEventListener('mouseup', this.listeners.mouseup, false);
    canvas.addEventListener('mousedown', this.listeners.mousedown, false);
    canvas.addEventListener('mouseout', this.listeners.mouseup, false);
    document.onselectstart = e => this.preventSelection(e);
    setTimeout(() => {
      this.setState({ showHelper: false });
    }, 3e3);
  }
  componentDidUpdate() {
    const context = ReactDom.findDOMNode(this.refs.canvas).getContext('2d');
    context.clearRect(0, 0, this.props.width, this.props.height);
    this.addImageToCanvas(context, this.state.image);
  }
  // make sure we clean up listeners when unmounted.
  componentWillUnmount() {
    const canvas = ReactDom.findDOMNode(this.refs.canvas);
    canvas.removeEventListener('mousemove', this.listeners.mousemove);
    canvas.removeEventListener('mouseup', this.listeners.mouseup);
    canvas.removeEventListener('mousedown', this.listeners.mousedown);
    canvas.removeEventListener('mouseout', this.listeners.mouseup);
  }
  prepareCanvas = () => {
    // set the right canvas size to fill the modal content box
    const canvasContainerDOM = ReactDom.findDOMNode(this.refs.canvasContainer);
    if (canvasContainerDOM) {
      const modalContentWidth = canvasContainerDOM.getBoundingClientRect().width;
      const defaultCanvasWidth = this.props.round ? this.props.height : this.props.width;
      const defaultCanvasHeight = this.props.height;
      // update only if the canvas size is smaller than the modal content size
      if (modalContentWidth < defaultCanvasWidth) {
        const imageRatio = 1 / defaultCanvasWidth * modalContentWidth;
        const canvasWidth = modalContentWidth;
        const canvasHeight = defaultCanvasHeight * imageRatio;
        this.setState({ canvasWidth, canvasHeight, imageRatio });
      } else {
        this.setState({ imageRatio: 1 });
      }
    }
  }
  prepareImage = imageUri => {
    const img = new Image();
    if (!isDataURL(imageUri)) img.crossOrigin = 'anonymous';
    img.onload = () => {
      const scaledImage = this.fitImageToCanvas(img.width, img.height);
      scaledImage.resource = img;
      scaledImage.x = 0;
      scaledImage.y = 0;
/*      const yCompensation = (((scaledImage.height * this.state.imageRatio) - this.state.canvasHeight) * -1);
      console.log(yCompensation, scaledImage.height, this.state.canvasHeight);*/
      this.setState({ dragging: false, image: scaledImage, preview: this.toDataURL() });
    };
    img.src = imageUri;
  };
  mouseDownListener = (e) => {
    this.setState({
      image: this.state.image,
      dragging: true,
      mouse: {
        x: null,
        y: null,
      },
    });
  };
  preventSelection = (e) => {
    if (this.state.dragging) {
      e.preventDefault();
      return false;
    }
  };
  mouseUpListener = () => {
    this.setState({ dragging: false, preview: this.toDataURL() });
  }
  mouseMoveListener = (e) => {
    if (!this.state.dragging) return;
    const mouseX = e.clientX;
    const mouseY = e.clientY;
    const imageX = this.state.image.x;
    const imageY = this.state.image.y;
    const newImage = this.state.image;
    if (this.state.mouse.x && this.state.mouse.y) {
      const dx = this.state.mouse.x - mouseX;
      const dy = this.state.mouse.y - mouseY;
      const bounded = this.boundedCoords(imageX, imageY, dx, dy);
      newImage.x = bounded.x;
      newImage.y = bounded.y;
    }
    this.setState({
      image: this.state.image,
      mouse: {
        x: mouseX,
        y: mouseY,
      },
    });
  };
  boundedCoords = (x, y, dx, dy) => {
    // calculate the image size
    const { canvasWidth, canvasHeight, zoom } = this.state;
    const scaledWidth = this.state.image.width * zoom;
    const scaledHeight = this.state.image.height * zoom;
    const yCompensation = ((this.state.image.height) - canvasHeight) / 2 * -1;
    const xCompensation = ((this.state.image.width) - canvasWidth) / 2 * -1;

    let newX = x - dx;
    let newY = y - dy;

    const rangeX = scaledWidth - canvasWidth;
    const rangeY = scaledHeight - canvasHeight;

    const lowX = (rangeX / 2 * -1) + xCompensation;
    const highX = rangeX / 2;
    if (newX < lowX) {
      newX = lowX;
    } else if (newX > highX) {
      newX = highX;
    }

    const lowY = (rangeY / 2 * -1) + yCompensation;
    const highY = rangeY + lowY;
    if (newY < lowY) {
      newY = lowY;
    } else if (newY > highY) {
      newY = highY;
    }

    // console.log({ canvasWidth, canvasHeight, scaledWidth, scaledHeight });
    // console.log({ yCompensation });
    // console.log({ x, y, zoom, newX, newY });
    // console.log({ lowX, highX });
    // console.log({ rangeX, rangeY, lowY, highY });

    return {
      x: newX,
      y: newY,
    };
  };
  fitImageToCanvas = (width, height) => {
    let scaledHeight;
    let scaledWidth;
    const { canvasWidth, canvasHeight } = this.state;
    if (Math.round(canvasWidth * (height / width)) >= canvasHeight) {// scroll on H
      scaledWidth = canvasWidth;
      scaledHeight = Math.round(scaledWidth * (height / width));
    } else { // scroll on W
      scaledHeight = canvasHeight;
      scaledWidth = Math.round(scaledHeight * (width / height));
    }

    return { width: scaledWidth, height: scaledHeight };
  };
  addImageToCanvas = (context, image) => {
    if (!image.resource) return;
    context.save();
    context.globalCompositeOperation = 'destination-over';
    const { zoom, canvasWidth, canvasHeight } = this.state;
    const scaledWidth = this.state.image.width * zoom;
    const scaledHeight = this.state.image.height * zoom;
    let x = image.x - (scaledWidth - this.state.image.width) / 2;
    let y = image.y - (scaledHeight - this.state.image.height) / 2;
    // need to make sure we aren't going out of bounds here...
    x = Math.min(x, 0);
    y = Math.min(y, 0);
    x = Math.max(x, canvasWidth - scaledWidth);
    y = Math.max(y, canvasHeight - scaledHeight);
    context.drawImage(image.resource, x, y, image.width * zoom, image.height * zoom);
    context.restore();
  };
  toDataURL = () => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = this.state.canvasWidth;
    canvas.height = this.state.canvasHeight;
    this.addImageToCanvas(context, {
      resource: this.state.image.resource,
      x: this.state.image.x,
      y: this.state.image.y,
      height: this.state.image.height,
      width: this.state.image.width,
    });
    return canvas.toDataURL();
  };
  handleCrop = () => {
    const data = this.toDataURL();
    this.props.onCrop(data);
  };
  handleZoomUpdate = (_, val) => {
//    console.log({ zoom: val });
    this.setState({ zoom: val });
  };
  render() {
    const canvasStyle = {
      border: '2px dashed #efefef',
      cursor: 'move',
      backgroundColor: '#1b2936',
    };
    if (this.props.round) { // make it round
      canvasStyle['-moz-border-radius'] = `${this.props.height}px`;
      canvasStyle['-webkit-border-radius'] = `${this.props.height}px`;
    }
    const helperStyle = {
      display: this.state.showHelper ? 'block' : 'none',
      position: 'absolute',
      width: '224px',
      height: '34px',
      left: '50%',
      top: '50%',
      border: '1px solid white',
      backgroundColor: 'rgba(0,0,0,0.5)',
      color: 'white',
      marginLeft: '-113px',
      marginTop: '-108px',
      padding: '5px',
      userSelect: 'none',
    };
    return (
      <div style={{ textAlign: 'center' }} ref="canvasContainer">
        <div style={helperStyle}>
        <Icon className="tc-icon-cursor-default-outline" style={{ fontSize: '17px' }} /> Drag to Reposition Image
        </div>
        <div>
          <canvas
            style={canvasStyle}
            ref="canvas"
            width={this.state.canvasWidth}
            height={this.state.canvasHeight}
          />
        </div>
        <Slider
          ref="zoom"
          name="zoom"
          onChange={this.handleZoomUpdate}
          min={1}
          max={3}
          step={0.01}
          value={this.state.zoom}
          defaultValue={1}
        />
        <div>
          <RaisedButton
            onTouchTap={this.props.onRequestHide}
            label={this.props.cancelButtonLabel}
          />
          <RaisedButton
            secondary
            style={{ marginLeft: '6px' }}
            onTouchTap={this.handleCrop.bind(this)}
            label={this.props.cropButtonLabel}
          />
        </div>
      </div>
    );
  }
}
Cropper.propTypes = {
  image: React.PropTypes.string.isRequired,
  onCrop: React.PropTypes.func.isRequired,
  cancelButtonLabel: React.PropTypes.string,
  cropButtonLabel: React.PropTypes.string,
  width: numberableType,
  height: numberableType,
  onRequestHide: React.PropTypes.func.isRequired,
  round: React.PropTypes.bool.isRequired,
};
Cropper.defaultProps = {
  width: 400,
  height: 400,
  cancelButtonLabel: 'Cancel',
  cropButtonLabel: 'Crop and Save',
  round: false,
};

export default Cropper;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/image-crop/image-crop.js